import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Modal, Input, notification } from "antd";
import styles from "./DashBoard.module.scss";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import { useWindowSize } from "../../hooks/useWindowSize";
import { addTripAsFavorite } from "../../services";
import { Radio } from "@mtm/components";
import DashBoardTable from "./DashBoardTable";
import CollapsibleTrips from "../Shared/CollapsibleTrips/CollapsibleTrips";
import { useHistory } from "react-router-dom";
import { usePaginationCtx } from "../../context/PaginationContext";
import { TrackAnalytics } from "../../types/ApplicationTypes";

type Props = {
  favRecords: any;
  favModalVisible: boolean;
  setFavModalVisible: any;
  isDesktop: boolean;
};

const DashboardFavoriteModal: React.FC<Props> = ({
  favRecords,
  favModalVisible,
  setFavModalVisible,
  isDesktop,
}) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false); //multiple
  const [isFavModalVisible, setIsFavModalVisible] = useState<boolean>(false); //name
  const [favoriteCount, setFavoriteCount] = useState<string>("single");
  const [favoriteName, setFavoriteName] = useState<string>("");

  const { width } = useWindowSize();

  const history = useHistory();

  useEffect(() => {
    if (width <= 992 && isDesktop) {
      isModalVisible && setIsModalVisible(false);
      isFavModalVisible && setIsFavModalVisible(false);
    }
  }, [width, isDesktop]);

  useEffect(() => {
    if (favModalVisible && favRecords?.allLegs.length > 1) {
      setIsModalVisible(true);
    } else if (favModalVisible && favRecords?.selectedLeg.length === 1) {
      setIsFavModalVisible(true);
    }
  }, [favModalVisible, favRecords]);

  const favoriteOptions = ["single", "multiple"];

  const [single] = useState([
    { id: 1, value: "single", name: "This service only" },
  ]);

  const { multiple } = useMemo(() => {
    const multiple = [
      {
        id: 2,
        value: "multiple",
        name: `Whole booking (${favRecords?.legsCount} services)`,
      },
    ];
    return { multiple };
  }, [favRecords?.legsCount]);

  const handlefavModalClose = () => {
    setIsModalVisible(false);
    setIsFavModalVisible(false);
    setFavModalVisible(false);
    setFavoriteCount("single");
    setFavoriteName("");
    !isDesktop &&
      history.push(`/DashBoardMobile/ProfileMobilePage/pastServices`);
  };

  const handleFavModalSave = () => {
    setIsModalVisible(false);
    setIsFavModalVisible(true);
  };

  const handleFavNameSave = async () => {
    let bookingIds: number[] = [];
    let personId = 0;
    let favoriteId = 0;
    let records =
      favoriteCount === "single"
        ? favRecords?.selectedLeg
        : favRecords?.allLegs;
    records.forEach((trip: ITripDetails) => {
      if (
        trip.requestAssignmentId ===
        favRecords?.selectedLeg[0].requestAssignmentId
      ) {
        bookingIds.push(Number(trip.bookingId));
        personId = trip.personId;
        favoriteId = trip.favoriteId;
      }
    });

    try {
      const data = {
        personId: personId,
        name: favoriteName.trimEnd(),
        bookingId: bookingIds,
        requestAssignmentId: favRecords.allLegs[0].requestAssignmentId,
        favoriteId: favoriteId,
      };
      const result = await addTripAsFavorite(data);
      if (result.isUpdated) {
        notification.success({
          message: "Success",
          description: "Trip has been successfully added as a favorite.",
        });
        TrackAnalytics(
          "/DashBoard",
          "Set trip as favorite",
          "DashBoard Favorite Modal"
        );
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to add trip as favorite.",
      });
    }
    setIsFavModalVisible(false);
    setFavModalVisible(false);
    setFavoriteCount("single");
    setFavoriteName("");
    !isDesktop && history.push(`/DashBoardMobile/ProfileMobilePage/favorites`);
  };

  const handleFavoriteNameChange = (value: string) => {
    let name = value.replace(/[^a-z0-9\s]/gi, "");
    const newValue = name.replace(/\s\s+/g, " ");
    if (newValue.trimStart() === newValue) {
      setFavoriteName(newValue);
    }
  };

  const handleChooseFavorites = (e: any) => {
    setFavoriteCount(e.target.value);
  };

  return (
    <div>
      <Modal
        visible={isFavModalVisible}
        centered
        width="unset"
        className={styles.modalFavContainer}
        footer={
          <Row justify="center" gutter={[10, 0]} className={styles.modalBtns}>
            <Col>
              <Button
                className={styles.modalCloseBtn}
                onClick={handlefavModalClose}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                disabled={favoriteName.trimEnd().length >= 3 ? false : true}
                className={
                  favoriteName.trimEnd().length >= 3
                    ? "wandaBtnEnabled " + styles.modalYesBtn
                    : "wandaBtnDisabled " + styles.modalYesBtn
                }
                onClick={handleFavNameSave}
              >
                Save Favorite
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center">
          <Col className={styles.modalHeading}>Add Favorite</Col>
        </Row>
        <Row justify="center" className={styles.modalContent}>
          <Col>Enter a name for your favorite:</Col>
        </Row>
        <Row justify="center" className={styles.modalContent}>
          <Col>
            <Input
              onChange={(e) => handleFavoriteNameChange(e.target.value)}
              placeholder="Example: John’s doctor"
              className={styles.modalFavInbox}
              value={favoriteName}
              maxLength={35}
            />
          </Col>
        </Row>
      </Modal>
      <Modal
        visible={isModalVisible}
        className={styles.modalFavOptContainer}
        centered
        width="unset"
        footer={
          <Row
            justify="center"
            gutter={[10, 0]}
            className={styles.modalBtns + " " + styles.modalFavBtns}
          >
            <Col>
              <Button
                className={styles.modalCloseBtn}
                onClick={handlefavModalClose}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className={styles.modalYesBtn}
                onClick={handleFavModalSave}
              >
                Confirm
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center">
          <Col className={styles.modalHeading}>Add Favorite</Col>
        </Row>
        <Row justify="center" className={styles.modalContent}>
          <Col className={styles.modalFavText}>
            This service is part of a booking with multiple services.
          </Col>
          <Col>
            Do you want to favorite just this service or the whole booking?
          </Col>
        </Row>
        <Row className={styles.modalContent}>
          <Col>
            {favoriteOptions.map((opt) => (
              <div key={opt}>
                {
                  <Row>
                    <div className={styles.modalRadioBtn}>
                      <Radio
                        radioList={opt === "single" ? single : multiple}
                        clickHandler={handleChooseFavorites}
                        value={favoriteCount}
                      />
                    </div>
                    {opt === favoriteCount && (
                      <Col>
                        <Row justify="center">
                          <Col xs={24} lg={0}>
                            <div className={styles.collapsibleMobileView}>
                              <CollapsibleTrips
                                dataSource={
                                  opt === "single"
                                    ? favRecords?.selectedLeg
                                    : favRecords?.allLegs
                                }
                              />
                            </div>
                          </Col>
                          <Col xs={0} lg={22}>
                            {favRecords && (
                              <DashBoardTable
                                dataSource={
                                  opt === "single"
                                    ? favRecords?.selectedLeg
                                    : favRecords?.allLegs
                                }
                                isCalling="YourPlan"
                                hideNoServiceMessage={true}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                }
              </div>
            ))}
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default DashboardFavoriteModal;
